import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./AccessLogUIHelpers";

const AccessLogUIContext = createContext();

export function useAccessLogUIContext() {
  return useContext(AccessLogUIContext);
}

export const AccessLogUIConsumer = AccessLogUIContext.Consumer;
export function AccessLogUIProvider({
  accessLogUIEvents,
  children,
  queryParams,
  setQueryParamsBase,
  ids,
  setIds,
}) {
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openReceiptDialog: accessLogUIEvents.openReceiptDialog,
    openDeleteDialog: accessLogUIEvents.openDeleteDialog,
  };

  return (
    <AccessLogUIContext.Provider value={value}>
      {children}
    </AccessLogUIContext.Provider>
  );
}
